/** Icona PrimeIcons accanto al testo di un bottone: decorativa, nascosta ai lettori di schermo. */
export const Icona = ({ nome }) => <i className={`pi ${nome}`} aria-hidden="true" />
